<template>
    <h2>Odborná prax</h2>
    <v-row align="center" style="margin:1px">
        <a href="https://www.aplikovanainformatika.sk/ai_zone/data/Pokyny_k_praxi-AI-2025.pdf">
           <v-btn size="small" variant="outlined" style="margin-right:1px">Pokyny</v-btn>
        </a>
        <v-spacer />
            <v-btn size="small" variant="outlined" style="margin-right:1px" @click="button_selection = 1" v-if="user_type == 'teacher'">Hodnotenie</v-btn>
            <v-btn size="small" variant="outlined" style="margin-right:1px" @click="button_selection = 3" v-if="user_type == 'teacher'">Celkové výsledky</v-btn>
    </v-row>    

    <v-card-text>
        <MyPractices v-if="user_type == 'student'" />
        <PracticeEvaluation v-if="button_selection == 1" />
        <PracticeResults v-if="button_selection == 2" />
        <AllPracticeResults v-if="button_selection == 3" />
    </v-card-text>
</template>

<script>
import axios from '../../axios-auth.js'
import MyPractices from '../../components/practice/my_practices.vue'
import PracticeEvaluation from '../../components/practice/practice_evaluation.vue'
import PracticeResults from '../../components/practice/practice_results.vue'
import AllPracticeResults from '../../components/practice/all_practice_results.vue'

export default {
        data() {
            return {
                button_selection: 0,
                user_type: ''
        }
    },
    components: {
        MyPractices,
        PracticeEvaluation,
        PracticeResults,
        AllPracticeResults
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.getUserType()
        },
        getUserType() {
            axios.get('/get-practice-user-type', this.$store.getters.getAxiosConfig)
            .then(res => {
                this.user_type = res.data.result  
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
    }
}
</script>